
import { AbhyasaBharathiMagazine } from "../schoolPrograms/abhyasaBharathi/abhyasaBharathi";
import { Inistitution } from "./institution";



export const SchoolAbhyasaBharathi = () => {

    return (<>
        <Inistitution>
            <AbhyasaBharathiMagazine isAddFilesVisible={false} isDeleteFilesVisible={false} />

        </Inistitution>
    </>);
}